import Vue from "vue";
import Vuetify from "vuetify/lib/framework";

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: "#4F74E3",
        secondary: "#6FACDE",
        accent: "#A4C8E1",
        error: "#b71c1c",
      },
    },
  },
});
